
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/moja-karta/odblokowanie-karty-sim",
      function () {
        return require("private-next-pages/moje-konto/moja-karta/odblokowanie-karty-sim.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/moja-karta/odblokowanie-karty-sim"])
      });
    }
  